import { useEffect, useState } from "react"
import { FormHelperText } from "@mui/material"
import { useFormikContext } from "formik"

import { useAppLocalization } from "../../../../../modules/localization/components/AppLocalizationProvider"
import { DynamicConfigKey, DynamicMainFormValues } from "../../../createOrder/components/form/formTypes"

import { attendeeInitValues, CreateUpdateAttendeesForm } from "./attendeesForm/CreateUpdateAttendeesForm"
import { CreateUpdateAttendeesFormValues } from "./attendeesForm/attendeesTypes"

export function AttendeesFormPart() {
    const { l10n } = useAppLocalization()
    const [pendingSubmit, setPendingSubmit] = useState(false)

    const { values, errors, submitCount, setFieldValue, submitForm } = useFormikContext<DynamicMainFormValues>()

    // Submitting synchronously after setFieldValue would validate and submit the previous form
    // state (Formik refreshes its internals only on commit), so defer the submit to an effect
    // that runs after the attendees value has been flushed.
    useEffect(() => {
        if (!pendingSubmit) return
        setPendingSubmit(false)
        void submitForm()
    }, [pendingSubmit, submitForm])

    const handleChangeAttendees = (attendeesList: CreateUpdateAttendeesFormValues) => {
        setFieldValue(DynamicConfigKey.ADD_PARTICIPANTS_FORM, [...attendeesList.attendees])
        setPendingSubmit(true)
    }

    const attendees = values[DynamicConfigKey.ADD_PARTICIPANTS_FORM]
    const participantsError = errors[DynamicConfigKey.ADD_PARTICIPANTS_FORM]

    return (
        <>
            <CreateUpdateAttendeesForm
                initialValues={{ attendees: attendees?.length ? attendees : [attendeeInitValues] }}
                handleChangeAttendees={handleChangeAttendees}
                submitButtonText={l10n.getString("create-order-confirm-booking-dialog-submit-button")}
            />
            {submitCount > 0 && typeof participantsError === "string" && (
                <FormHelperText error>{participantsError}</FormHelperText>
            )}
        </>
    )
}
